import React, { Component } from 'react';
import TitleBar from '../../components/title_bar';
import chkMark from '../../images/checkmark.gif';
import '../../css/common.css';
import '../../css/contact.css';

export default class Contact extends Component {

  constructor(props) {
    super(props);

    this.state = { temp: true }
  }

  sendMail() {
  const name = this.refs.txtContactName.value;
  const email = this.refs.txtContactEmail.value;
  const msg = this.refs.txtContactMessage.value;

  const url = `http://www.cognarium.com:85/api/comm/SendToDineStein?name=${name}&replyTo=${email}&msg=${msg}`;
  fetch(url, {'mode': 'no-cors'})
    .then(result=> {
      document.all('contact-form').style.display = 'none';
      document.all('mail-sent').style.display = '';
    });
  }

  render() {
    return (
      <div id="bk-div" className="light-bk">
         <div className="title-bar-offset1">
           <TitleBar showContact={false} showBack={true} />
           <div className="section-title-white highlight-font"><span>Contact Us</span></div>
         </div>
         <div id="contact-form" className="main-font">
           <span className="contact-section-lrg main-font">Send Message</span>
           <input className="contact-form-sngl contact-section-sm" id="txtContactName" placeholder="Name" ref="txtContactName" />
           <input type="email" className="contact-form-sngl contact-section-sm" id="txtContactEmail" ref="txtContactEmail" placeholder="Email" />
           <textarea className="contact-form-multi contact-section-sm" id="txtContactMessage" ref= "txtContactMessage" placeholder="Message" />
           <div id="contact-send" className="btn-bk" onClick={()=>{this.sendMail()}}>Send</div>
         </div>
         <div id="mail-sent" style={{display: 'none'}}>
           <img id="checkmark" src={chkMark} alt="" />
           <div id="mailgood" classname="main-font">Thank you for your note. We will get back to you shortly.</div>
         </div>
         <div id="contact-footer">
           <div className="contact-section-lrg main-font">myDineStein</div>
           <div className="contact-section-sm main-font">618 Tupelo Way Chaska, MN 55318</div>
           <div className="contact-section-sm main-font">+1 612.803.5992</div>
           <div></div>
         </div>
       </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/pages/contact/contact.js